import {
  productHasCcwVariantPricing,
  productSupportsVehicleTypeSelection,
  resolveCcwMonthlyPrice,
} from "./selfSignupPricing";

const VEHICLE_TYPES = [
  { key: "sedan", label: "Sedan/Hatch" },
  { key: "wagon", label: "SUV/Wagon" },
  { key: "4wd", label: "4WD/7 Seater" },
];

function parseNonNegativeNumber(value) {
  if (value == null || value === "") return null;
  const n = parseFloat(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

function parsePositiveNumber(value) {
  if (value == null || value === "") return null;
  const n = parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function annualRrpFromMonthly(monthly) {
  const n = parseNonNegativeNumber(monthly);
  return n == null ? null : Math.round(n * 12);
}

export function monthlyFromAnnualRrp(annual) {
  const n = parseNonNegativeNumber(annual);
  return n == null ? null : n / 12;
}

function inferVehicleTypeFromName(name) {
  const n = String(name || "").toLowerCase();
  if (/\b4wd\b|7\s*seater|seven\s*seater/.test(n)) return "4wd";
  if (/\bwagon\b|\bsuv\b/.test(n)) return "wagon";
  if (/\bsedan\b|\bhatch\b/.test(n)) return "sedan";
  return null;
}

function catalogAnnualRrp(product) {
  const fromRrp = parseNonNegativeNumber(product?.rrp);
  if (fromRrp != null) return Math.round(fromRrp);
  if (product?.interval === "month") {
    const annual = annualRrpFromMonthly(product?.price);
    if (annual != null) return annual;
  }
  const fromPrice = parseNonNegativeNumber(product?.price);
  return fromPrice == null ? null : Math.round(fromPrice);
}

export function buildSalesforceSignupLinks(product) {
  if (!product?._id) return [];

  const productId = product._id;
  const lockInPeriodMonths = product.lockInPeriodMonths;
  const inferredVehicle = inferVehicleTypeFromName(product.name);
  const usesVariantPricing = productSupportsVehicleTypeSelection(productId, product);

  if (usesVariantPricing && (productHasCcwVariantPricing(product) || product.supportsVehicleVariantPricing)) {
    return VEHICLE_TYPES.map(({ key, label }) => {
      const ccwMonthly = resolveCcwMonthlyPrice(productId, key, product);
      const merchantMonthly = parsePositiveNumber(product?.vehicleTypeBasePricing?.[key]);
      const monthly = ccwMonthly ?? merchantMonthly;
      const rrp = annualRrpFromMonthly(monthly) ?? catalogAnnualRrp(product);
      return {
        label,
        vehicleType: key,
        monthly: monthly ?? monthlyFromAnnualRrp(rrp),
        rrp,
        lockInPeriodMonths,
        url: null,
      };
    }).filter((row) => row.rrp != null);
  }

  const rrp = catalogAnnualRrp(product);
  if (rrp == null) return [];

  return [
    {
      label: inferredVehicle
        ? VEHICLE_TYPES.find((v) => v.key === inferredVehicle)?.label || inferredVehicle
        : "Default",
      vehicleType: inferredVehicle,
      monthly: monthlyFromAnnualRrp(rrp),
      rrp,
      lockInPeriodMonths,
      url: null,
    },
  ];
}

export function salesforceLinkKey(link) {
  return link?.vehicleType || "default";
}

export function applySalesforceLinkRrp(link, annualRrp) {
  const rrp = parseNonNegativeNumber(annualRrp);
  return {
    ...link,
    rrp: rrp == null ? null : Math.round(rrp),
    monthly: monthlyFromAnnualRrp(rrp),
  };
}
